import { Capacitor } from "@capacitor/core";

// True inside the Android/iOS store apps, where Stripe checkout is not allowed.
export const isNativeApp = () => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
};
